module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="l-simplePanel__splitA">\r\n    <div class="l-simplePanel__panelA">\r\n    </div>\r\n</div>';
}
return __p;
};
